import React from 'react';
import {
  Textarea,
} from 'shared/components';
import { useTranslation } from 'react-i18next';
import { IRREGULARITIES_NOTES_MAX_LENGTH } from 'shared/constants';
import PropTypes from 'prop-types';

const CloseInAdvance = ({
  inputValue,
  handleInputChange,
  errors,
}) => {
  const { t } = useTranslation();
  return (
    <div className="close-in-advance-container">
      <h3>{t('reviewAndCloseRoom.examineeStatus.closeInAdvance')}</h3>
      <Textarea
        name="irregularities"
        label={t('reviewAndCloseRoom.examineeStatus.closeLabel')}
        value={inputValue.irregularities}
        onChange={handleInputChange}
        maxLength={IRREGULARITIES_NOTES_MAX_LENGTH}
        error={errors.irregularities}
        required
      />
    </div>
  );
};

export default CloseInAdvance;

CloseInAdvance.propTypes = {
  handleInputChange: PropTypes.func.isRequired,
  inputValue: PropTypes.shape({}).isRequired,
  errors: PropTypes.shape({}).isRequired,
};
